export default "__VITE_ASSET__BACldXvP__"